// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__nBc5W","resendInfoText":"OnGoingPaymentBox_resendInfoText__36tT0"};